const betPanelManagerModel = {
  state: {
    areAllBetSlipsExpanded: true,
    totalBetSlips: 0,
    totalSingleBetSlips: 0,
    totalBetBuilderBetSlips: 0,
    totalCollapsedBetSlips: 0,
    totalExpandedBetSlips: 0,
  },
  reducers: {
    updateBetPanelState: (state: Record<string, any>, payload: any) => {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {},
};
export default betPanelManagerModel;
